// src/pages/Operator/IbadahKompelka/IbadahKompelka.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
// Sesuaikan path import komponen dan firebase
import { Footer, NavBarLogin } from "../../../components"; 
import { db } from "../../../config/firebase"; 
import { ref, set, onValue } from "firebase/database";
import "./ibadahKompelka.scss"; 

const initialJadwal = {
    pkb: { nama: "Ibadah Pria Kaum Bapa", waktu: "", lokasi: "" },
    wki: { nama: "Ibadah Wanita Kaum Ibu", waktu: "", lokasi: "" },
    pemuda: { nama: "Ibadah Pemuda Jemaat", waktu: "", lokasi: "" },
    remaja: { nama: "Ibadah Remaja Jemaat", waktu: "", lokasi: "" },
    anak: { nama: "Ibadah Anak Sekolah Minggu", waktu: "", lokasi: "" },
    lansia: { nama: "Ibadah Lansia", waktu: "", lokasi: "" },
};

const IbadahKompelka = () => {
    const navigate = useNavigate();
    const [jadwal, setJadwal] = useState(initialJadwal);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const FIREBASE_NODE = "jadwal_ibadah_kompelka";

    // 1. Ambil Data Awal (Pre-fill Form)
    useEffect(() => {
        const jadwalRef = ref(db, FIREBASE_NODE);
        const unsubscribe = onValue(jadwalRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                // Merge data dari Firebase dengan initial state untuk memastikan semua key ada
                setJadwal(prev => ({
                    ...prev,
                    pkb: data.pkb || prev.pkb,
                    wki: data.wki || prev.wki,
                    pemuda: data.pemuda || prev.pemuda,
                    remaja: data.remaja || prev.remaja,
                    anak: data.anak || prev.anak,
                    lansia: data.lansia || prev.lansia,
                }));
            }
        }, (error) => {
             console.error("Gagal membaca jadwal dari Firebase:", error);
        });

        return () => unsubscribe();
    }, []);

    // 2. Handler Input
    const handleChange = (kompelkaKey, field, value) => {
        setJadwal(prev => ({
            ...prev,
            [kompelkaKey]: {
                ...prev[kompelkaKey],
                [field]: value,
            },
        }));
    };

    // 3. Clear Form
    const clearForm = () => {
        // Kosongkan semua field, tapi pertahankan nama kompelka
        setJadwal(prev => Object.fromEntries(
            Object.entries(prev).map(([key, item]) => [
                key,
                { ...item, waktu: "", lokasi: "" }
            ])
        ));
    };

    // 4. Handler Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        // Basic validation: Cek apakah semua field waktu terisi
        const isAllFilled = Object.values(jadwal).every(item => item.waktu.trim() !== "" && item.lokasi.trim() !== "");
        if (!isAllFilled) {
             setMessage("❌ Pastikan semua kolom Waktu dan Lokasi terisi.");
             setLoading(false);
             setTimeout(() => setMessage(""), 5000);
             return;
        }

        const jadwalRef = ref(db, FIREBASE_NODE);

        try {
            await set(jadwalRef, jadwal);
            setMessage("✅ Jadwal Kompelka berhasil diupdate!");
            clearForm(); // Kosongkan form setelah sukses

        } catch (error) {
            console.error("Gagal mengupdate jadwal Kompelka:", error);
            setMessage("❌ Gagal mengupdate jadwal. Cek konsol untuk detail.");
        } finally {
            setLoading(false);
            setTimeout(() => setMessage(""), 5000); 
        }
    };

    // 5. Render Helper untuk Form Input
    const renderKompelkaForm = (key) => {
        const item = jadwal[key];
        return (
            <div key={key} className="kompelka-group">
                <h4>{item.nama}</h4>
                <div className="form-group">
                    <label htmlFor={`${key}-waktu`}>Waktu (Contoh: Setiap Jumat | Pkl. 19.00 WITA):</label>
                    <input
                        id={`${key}-waktu`}
                        type="text"
                        value={item.waktu}
                        onChange={(e) => handleChange(key, 'waktu', e.target.value)}
                        required
                        placeholder="Setiap Hari | Pkl. XX.XX WITA"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor={`${key}-lokasi`}>Lokasi (Contoh: Gedung GMIM Genesaret atau Kolom XX):</label>
                    <input
                        id={`${key}-lokasi`}
                        type="text"
                        value={item.lokasi}
                        onChange={(e) => handleChange(key, 'lokasi', e.target.value)}
                        required
                        placeholder="Lokasi Ibadah"
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="ibadah-kompelka-page">
            <NavBarLogin />
            <section className="update-form-section">
                
                <div className="form-header-action">
                    <button 
                        onClick={() => navigate('/operator')} 
                        className="stylish-back-button" 
                        disabled={loading}
                    >
                        <span aria-hidden="true">←</span> Dashboard Operator
                    </button>
                    <div className="header-content">
                        <h2>🗓️ Update Jadwal Ibadah Kompelka</h2>
                        <p>Silakan update Waktu dan Lokasi untuk semua Kelompok Pelayanan Kategorial.</p>
                    </div>
                </div>
                
                <form onSubmit={handleSubmit} className="kompelka-form">
                    {/* Render input untuk setiap Kompelka */}
                    {Object.keys(jadwal).map(renderKompelkaForm)}
                    
                    <button type="submit" disabled={loading}>
                        {loading ? "Menyimpan..." : "Simpan Jadwal Kompelka"}
                    </button>
                    
                    {message && <p className={`message ${message.startsWith('✅') ? 'success' : 'error'}`}>{message}</p>}
                </form>
            </section>
        </div>
    );
};

export default IbadahKompelka;